var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.8,88.4c0,3.7,3,6.6,6.7,6.6h45.1c3.7,0,6.7-2.9,6.7-6.6L81.9,34H18.3L20.8,88.4z M62,44.9c0-1.9,1.1-3.4,3-3.4     s3,1.5,3,3.4v37.6c0,1.9-1.1,3.4-3,3.4s-3-1.5-3-3.4V44.9z M47,44.9c0-1.9,1.1-3.4,3-3.4s3,1.5,3,3.4v37.6c0,1.9-1.1,3.4-3,3.4     s-3-1.5-3-3.4V44.9z M32,44.9c0-1.9,1.1-3.4,3-3.4s3,1.5,3,3.4v37.6c0,1.9-1.1,3.4-3,3.4s-3-1.5-3-3.4V44.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1,17H65V8.1C65,6.3,64.1,5,62.2,5H38c-1.9,0-3,1.3-3,3.1V17H17.1c-1.9,0-3.1,1.4-3.1,3.3v3.8c0,1.9,1.2,3.9,3.1,3.9     h66.1c1.9,0,2.9-2.1,2.9-3.9v-3.8C86,18.4,85,17,83.1,17z M59,17H41v-6h18V17z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.8e6211d5b35700aafc5baf95e34dbbc2.svg";
export { ForwardRef as ReactComponent };